import React from 'react';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import { getWebImageUrl } from '../../../utils/image';

const PoweredBy = props => {
  return (
    <Grid
      container
      wrap={window.innerWidth > 500 ? 'nowrap' : 'wrap'}
      spacing={1}
      className="powered-by"
      {...props}
      sx={[{
        justifyContent: "flex-end",
        alignItems: "center"
      }, ...(Array.isArray(props.sx) ? props.sx : [props.sx])]}>
      <Grid>
        <Typography style={{ whiteSpace: 'nowrap' }}>Powered by</Typography>
      </Grid>
      <Grid>
        <img src={getWebImageUrl('img/policy-review/PfplusIcon.png')} alt="powered-by-portfoplus" height="30" />
      </Grid>
      <Grid>
        <img src={getWebImageUrl('img/policy-review/FA2024_logo.png')} alt="fin-tech-awards-2024" height="30" />
      </Grid>
    </Grid>
  );
};

export default PoweredBy;
